import type { ModelFilterOptions } from '@/lib/api/models'

// Re-export CatalogModel from canonical source to avoid duplication
export type { CatalogModel } from '@/lib/api/models'

export type NodeTypeFilter = 'image' | 'video' | 'text-llm' | 'sound' | '3d' | ''
export type SortOption = 'featured' | 'name-asc' | 'name-desc'

export interface FilterPanelProps {
  activeNodeType: NodeTypeFilter
  category: string
  modelFamily: string
  sort: SortOption
  filterOptions: ModelFilterOptions
  hasActiveFilters: boolean
  onNodeTypeChange: (v: NodeTypeFilter) => void
  onCategoryChange: (v: string) => void
  onModelFamilyChange: (v: string) => void
  onSortChange: (v: SortOption) => void
  onClear: () => void
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

export function modelColor(id: string): string {
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    hash = (hash << 5) - hash + id.charCodeAt(i)
    hash |= 0
  }
  const hue = Math.abs(hash) % 360
  return `hsl(${hue}, 40%, 92%)`
}

export function modelSubtitle(model: { modelFamily?: string; provider?: { name: string }; category: string }): string {
  return model.modelFamily ?? model.provider?.name ?? model.category
}
